/* eslint-disable camelcase */
import { faCircleCheck, faCompass } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { formatDayLabel } from '../../../utils/formatDate';
import { formatCurrency } from '../../../utils/formatNumber';
import { getMealText } from '../../../utils/minside/meals';

function MealChoiceCard({ meal, label, checked, onToggle, disabled = false }) {
    const text = getMealText(meal, label);
    const pris = formatCurrency(meal?.pris, 0);

    return (
        <label
            className={`meal-choice ${checked ? 'is-selected' : ''} ${disabled ? 'is-disabled' : ''}`}
        >
            <input type="checkbox" checked={checked} onChange={onToggle} disabled={disabled} />

            <div className="meal-choice__content">
                <div className="meal-choice__top">
                    <span className="meal-choice__label">{label}</span>

                    {pris && <span className="meal-price-badge">{pris}</span>}
                </div>

                <h4 className="meal-choice__title">{formatDayLabel(meal.dato)}</h4>

                {text && (
                    <div className="meal-choice__location">
                        <FontAwesomeIcon icon={faCompass} />
                        {text}
                    </div>
                )}

                {checked && (
                    <span className="meal-choice__selected">
                        <FontAwesomeIcon icon={faCircleCheck} />
                    </span>
                )}
            </div>
        </label>
    );
}

export default MealChoiceCard;
